<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.6654 6.66699C22.6654 4.40033 20.932 2.66699 18.6654 2.66699C16.3987 2.66699 14.6654 4.40033 14.6654 6.66699C14.6654 7.73366 15.0654 8.66699 15.732 9.33366H14.6654C9.46536 9.33366 5.33203 13.467 5.33203 18.667C5.33203 21.6003 7.73203 24.0003 10.6654 24.0003"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.3993 5.20049C22.7993 4.80049 23.1993 4.53383 23.7327 4.26716C25.7327 3.46716 28.1327 4.40049 28.9327 6.40049C29.7327 8.40049 28.7993 10.8005 26.7993 11.6005L28.9327 15.3338C29.1994 15.7338 29.1993 16.2672 29.1993 16.6672C28.9327 17.7338 27.9994 18.2672 26.9327 18.1338C26.9327 18.1338 24.7993 17.7338 23.3327 17.3338H22.666C20.3993 17.3338 18.666 19.0672 18.666 21.3338"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5993 24C18.1115 23.4275 18.448 22.7197 18.5686 21.9611C18.6892 21.2025 18.5888 20.4252 18.2794 19.7221C17.9701 19.019 17.4648 18.4199 16.8241 17.9963C16.1833 17.5727 15.4341 17.3425 14.666 17.3333M17.3327 29.3333H5.33268C4.62544 29.3333 3.94716 29.0524 3.44706 28.5523C2.94697 28.0522 2.66602 27.3739 2.66602 26.6667C2.66602 25.9594 2.94697 25.2811 3.44706 24.781C3.94716 24.281 4.62544 24 5.33268 24H21.3327M21.3327 12H21.346"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'SmallMammalIcon',
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
